import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "typeSelect", "urlField", "videoUrlField", "fileField", "richTextField",
    "resourceableTypeSelect", "resourceableIdSelect"
  ]

  static values = {
    resourceables: { type: Object, default: {} }
  }

  connect() {
    this.toggleFields()
  }

  toggleFields() {
    const selectedType = this.typeSelectTarget.value

    this.hideAllFields()
    this.showFieldForType(selectedType)
  }

  loadResourceables() {
    const selectedType = this.resourceableTypeSelectTarget.value
    const selectElement = this.resourceableIdSelectTarget
    const items = this.resourceablesValue[selectedType] || []

    this.populateSelect(selectElement, items)
  }

  // --- Private helpers ---

  hideAllFields() {
    const fieldTargets = ["urlField", "videoUrlField", "fileField", "richTextField"]
    fieldTargets.forEach(targetName => {
      const hasMethod = `has${targetName.charAt(0).toUpperCase() + targetName.slice(1)}Target`
      if (this[hasMethod]) {
        const target = this[`${targetName}Target`]
        target.classList.add("hidden")
        this.setRequired(target, false)
      }
    })
  }

  showFieldForType(type) {
    const FIELD_MAP = {
      link: "urlField",
      video: "videoUrlField",
      file: "fileField",
      rich_text: "richTextField"
    }

    const targetName = FIELD_MAP[type]
    if (!targetName) return

    const hasMethod = `has${targetName.charAt(0).toUpperCase() + targetName.slice(1)}Target`
    if (this[hasMethod]) {
      const target = this[`${targetName}Target`]
      target.classList.remove("hidden")
      // rich_text n'est pas required côté model — seuls link/video/file le sont
      this.setRequired(target, type !== "rich_text")
    }
  }

  // Synchronise l'attribut HTML required + l'astérisque visuel sur le label,
  // puisque le rendu serveur fige ces deux marqueurs au moment du load.
  setRequired(wrapper, required) {
    const input = wrapper.querySelector("input, textarea, select")
    if (!input) return

    if (required) {
      input.setAttribute("required", "required")
    } else {
      input.removeAttribute("required")
    }

    const label = wrapper.querySelector("label")
    if (!label) return

    const existingMark = label.querySelector("[data-required-mark]")
    if (required && !existingMark) {
      const mark = document.createElement("span")
      mark.dataset.requiredMark = "true"
      mark.setAttribute("aria-hidden", "true")
      mark.className = "text-red-500 ml-0.5"
      mark.textContent = "*"
      label.appendChild(mark)
    } else if (!required && existingMark) {
      existingMark.remove()
    }
  }

  populateSelect(selectElement, items) {
    const currentValue = selectElement.value
    const promptText = selectElement.options[0]?.text || ""

    // Supprimer toutes les options existantes
    while (selectElement.firstChild) {
      selectElement.removeChild(selectElement.firstChild)
    }

    // Ajouter l'option prompt
    const promptOption = document.createElement("option")
    promptOption.value = ""
    promptOption.textContent = promptText
    selectElement.appendChild(promptOption)

    // Ajouter les nouvelles options
    items.forEach(item => {
      const option = document.createElement("option")
      option.value = item.id
      option.textContent = item.name
      selectElement.appendChild(option)
    })

    // Restaurer la sélection précédente si toujours disponible
    if (currentValue && items.some(item => String(item.id) === String(currentValue))) {
      selectElement.value = currentValue
    }
  }
}
